import * as React from "react";
const PlusIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <path
            d="M6 12h12m-6 6V6"
            stroke={props.color || "#FF8A65"}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default PlusIcon;
